export default __webpack_public_path__ + "media/images/user_photos/108-7ad8ac2d141a9b31cece951f831ab478.jpg";